<template>
  <div id="contract-detail">
    <div class="title">
      <h1>{{ $t('CONTRACT_INFO') }}</h1>
      <primary-button :text="$t('BACK')" blue @click="exit()" />
    </div>

    <b-container class="wrapper">
      <b-row>
        <b-col xs="12" md="4">
          <contract-info v-show="showContractInfo"/>
        </b-col>
        <b-col class="main" xs="12" :md="showContractInfo ? 8 : 12">
          <contract-tab v-model='tab'/>
          <div class="panel">
            <keep-alive>
              <component :is="component"></component>
            </keep-alive>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import PrimaryButton from '@/components/PrimaryButton';

import { PATHS } from '@/consts';

import ContractInfo from './ContractInfo';
import ContractTab from './ContractTab';
import SummaryInfoTab from './TabComponents/SummaryInfoTab';
import RepaymentScheduleTab from './TabComponents/RepaymentScheduleTab';
import TransactionTab from './TabComponents/TransactionTab';
import DocumentTab from './TabComponents/DocumentTab';
import CollateralInfoTab from './TabComponents/CollateralInfoTab';
import NoteTab from './TabComponents/NoteTab';
import TAB_NAMES from './TabComponents/tabs';

const { useActions: useContractActions } = createNamespacedHelpers('contractDetail');

export default {
  name: 'ContractDetail',
  components: {
    FontAwesomeIcon,
    ContractInfo,
    ContractTab,
    SummaryInfoTab,
    RepaymentScheduleTab,
    TransactionTab,
    DocumentTab,
    CollateralInfoTab,
    NoteTab,
    PrimaryButton
  },
  metaInfo() {
    const { $root: { $route } } = this;
    const title = `Contract #${$route.params.id}`;

    return {
      title,
      meta: []
    };
  },
  props: {
    id: [String, Number]
  },
  setup(props, { root: { $router } }) {
    const { getContractDetail } = useContractActions(['getContractDetail']);

    const contractId = computed(() => props.id);

    const tab = ref('NOTES');

    const component = computed(() => {
      switch (tab.value) {
        case TAB_NAMES.SUMMARY_INFO:
          return 'summary-info-tab';
        case TAB_NAMES.REPAYMENT_SCHEDULE:
          return 'repayment-schedule-tab';
        case TAB_NAMES.TRANSACTIONS:
          return 'transaction-tab';
        case TAB_NAMES.DOCUMENT:
          return 'document-tab';
        case TAB_NAMES.COLLATERAL_INFO:
          return 'collateral-info-tab';
        case TAB_NAMES.NOTES:
          return 'note-tab';
        default:
          return 'note-tab';
      }
    });

    const exit = () => { $router.push(PATHS.CONTRACTS); };

    const showContractInfo = computed(() => tab.value !== TAB_NAMES.REPAYMENT_SCHEDULE);

    watch(contractId, (id) => {
      if (!id) return;
      getContractDetail(id);
    }, {
      immediate: true
    });

    return {
      tab,
      component,
      exit,
      showContractInfo,
      faTimes,
      contractId
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#contract-detail {
  padding: 30px 0;

  .title {
    margin-bottom: 20px;
    margin-left: 20px;

    h1 {
      display: inline-block;
      font-size: 28px;
      vertical-align: middle;
    }

    .primary-button {
      display: inline-block;
      border-radius: 4px;
      margin-left: 20px;
      vertical-align: middle;
    }
  }

  .wrapper {
    margin: 0;

    .main {
      display: flex;
      flex-flow: column;

      .panel {
        flex-grow: 1;
        background-color: $babyPowder;
        border-radius: 4px;
      }
    }
  }
}
</style>
